export default class DiscountBlock
{
  private readonly clickHandler: EventListener;
  private readonly button: HTMLButtonElement;
  private readonly codeElement: HTMLPreElement;

  constructor(button: HTMLButtonElement) 
  {
    this.button = button;

    const codeElement = this.button.querySelector('pre');
    if(codeElement instanceof HTMLPreElement) {
      this.codeElement = codeElement;
    } else {
      throw new Error("code element not found");
    }

    this.clickHandler = this.handleClickEvent.bind(this);
    this.enable();
  }

  enable(): void
  {
    this.button.addEventListener('click', this.clickHandler, false);
  }

  private handleClickEvent(event: Event): void
  {
    switch(true)
    {
      case event.target == this.codeElement:
        if(this.codeElement.textContent) {
          navigator.clipboard.writeText(this.codeElement.textContent);
          this.codeElement.classList.add('is-copied');

          setTimeout(() => {
            this.codeElement.classList.remove('is-copied');
          }, 5000);
        }
        break;

      default:
        this.toggleFlip();
        break;
    }
  }

  private toggleFlip(): void
  {
    this.button.classList.toggle('is-flipped');
    this.codeElement.classList.remove('is-copied');
  }
}